import React from "react";
import { connect } from "react-redux";
import { getSurveyList } from "../../redux/action/user";
import Footer from "../../component/footer";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import HistoryHeader from "../../component/history/historyHeader";
import HistoryBody from "../../component/history/historyBody";

const History = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("userKey")) {
      navigate("/");
    }
    props.getSurveyList();
    localStorage.removeItem("review");
  }, []);

  return (
    <>
      <HistoryHeader />
      <div>
        <HistoryBody />
      </div>
      <Footer />
    </>
  );
};

History.propTypes = {};
History.defaultProps = {};

const actionCreators = {
    getSurveyList,
};

export default connect(
  ({ user }) => ({
    user,
  }),
  actionCreators
)(History);
